import React from 'react';
import { Table as AntTable } from 'antd';

/**
 * Wrapper component for Ant Design Table
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Table functionality and sub-components.
 * 
 * @component
 * @example
 * import { Table } from '../GeneralComponents/ui';
 * 
 * <Table
 *   dataSource={data}
 *   columns={columns}
 * />
 * 
 * // Column component (if needed)
 * <Table.Column title="Name" dataIndex="name" />
 * 
 * @see https://ant.design/components/table/ - Ant Design Table documentation
 */
const Table = (props) => {
  return <AntTable {...props} />;
};

// Preserve Table sub-components (if needed in future)
Table.Column = AntTable.Column;
Table.ColumnGroup = AntTable.ColumnGroup;
Table.Summary = AntTable.Summary;

export default Table;

